









































































































































































































































































































































































import Vue from "vue";
import SupportInfo from "./SupportInfo.vue";

export default Vue.extend({
  components: {
    SupportInfo,
  },
  methods: {
    skipStep() {
      this.$emit("skip");
    },
  },
});
